import { render } from "./salary-stats.vue?vue&type=template&id=1f22291c&scoped=true"
import script from "./salary-stats.vue?vue&type=script&lang=js"
export * from "./salary-stats.vue?vue&type=script&lang=js"

import "./salary-stats.vue?vue&type=style&index=0&id=1f22291c&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f22291c"]])

export default __exports__